<template>
  <div>
    <HearderTitle name="人事报表" />
    <div class="content">
      <div class="table-file">
        <a @click="download('list')" href="javascript:"><img src="../../assets/images/csv.png" /><br />员工花名册</a>
        <p id="listurl"></p>
      </div>
      <div class="table-file">
        <a @click="download('leave')" href="javascript:"><img src="../../assets/images/csv.png" /><br />离职员工</a>
        <p id="leaveurl"></p>
      </div>
      <div class="table-file">
        <a @click="download('book')" href="javascript:"><img src="../../assets/images/csv.png" /><br />员工通迅录</a>
        <p id="bookurl"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  import { exportPersonnelReport } from '@/api/personnelList.js'
  export default {
    name: 'personnelReport',
    methods: {
      async download(type) {
        let res = await exportPersonnelReport({ ac: type })
        if (res.status !== 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success('导出成功')
        const aLink = document.createElement('a')
        aLink.href = process.env.VUE_APP_UPLOAD_URL + res.data
        document.body.appendChild(aLink)
        aLink.click()
        document.body.removeChild(aLink)
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less" scoped>
  .content {
    margin: 0 auto;
    width: 700px;
    min-height: 825px;
  }
  .table-file {
    display: inline-block;
    margin: 40px 30px;
    outline: solid 1px #e6e6e6;
    text-align: center;
    a {
      color: #333;
      font-size: 12px;
    }
    p a {
      color: #f00;
      font-size: 12px;
    }
  }
</style>
